import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import { ContentLayout } from "../../layout/contentLayout";
import ImageBackground from "../ui-elements/image-background";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  CrownIcon,
  EditIcon,
  MessageDotIcon,
  NotificationSmallIcon,
} from "../ui-elements/svg-icons";
import BadgeImage from "../ui-elements/badge-image";
import { useNavigate } from "react-router-dom";
import { PATH_ACCOUNT, PATH_MESSAGES } from "../../routes/path";
import { RepresentativeAccountData } from "../../interface/representative";
import { SkeletonRepsAccountLoading } from "../ui-elements/skeleton-loading";
import { useMessaging } from "../../hooks/useMessaging";
import RepresentativeActivity from "./representative-activity";

const RepresentativeContent = ({
  reps_info,
}: {
  reps_info: RepresentativeAccountData;
}) => {
  const navigate = useNavigate();
  const { startNewChat, selectChat } = useMessaging();

  const createChat = () => {
    startNewChat({
      id: reps_info?.id,
      name: reps_info?.name,
      image: reps_info?.photo_url,
    });
    selectChat(reps_info.id);
    navigate(PATH_MESSAGES.root);
  };

  return (
    <ContentLayout>
      <Box
        sx={{
          maxWidth: 605,
          mx: "auto",
          py: "80px",
        }}
        id="main-scroll-container"
      >
        <ImageBackground
          sourceCover={
            reps_info?.cover_photo_url ?? "/assets/icons/icon-main.png"
          }
          account={false}
          sourceProfile={
            reps_info?.photo_url ?? "/assets/images/account/cover-bg.jpeg"
          }
        />
        <Stack
          direction={"row"}
          justifyContent={"flex-end"}
          sx={{ my: 3 }}
          spacing={2}
        >
          <Button
            onClick={createChat}
            variant="outlined"
            sx={{
              borderRadius: "60px",
              height: "2.5rem",
              minWidth: "20px",
              p: "8px",
            }}
          >
            <MessageDotIcon />
          </Button>
          <Button
            variant="contained"
            startIcon={<NotificationSmallIcon />}
            endIcon={<ArrowDropDownIcon />}
            sx={{
              borderRadius: "43px",
              minWidth: "120px",
              height: "2.5rem",
            }}
            onClick={() => navigate(PATH_ACCOUNT.edit)}
          >
            Notification
          </Button>
        </Stack>
        <Stack sx={{}}>
          <Stack direction={"row"} spacing={1} alignItems={"center"}>
            <Typography variant="body1" color="black" sx={{ fontWeight: 600 }}>
              {reps_info?.name}
            </Typography>
            <BadgeImage badge={2} />
          </Stack>

          <Stack sx={{ my: 1 }}>
            <Typography
              variant="body1"
              sx={{ fontWeight: 500, color: "#323F49" }}
            >
              Political Party
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 400, color: "#323F49" }}
            >
              {reps_info?.party ?? "-"}
            </Typography>
          </Stack>

          <Stack sx={{ my: 1 }}>
            <Typography
              variant="body1"
              sx={{ fontWeight: 500, color: "#323F49" }}
            >
              Position
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 400, color: "#323F49" }}
            >
              {reps_info?.position ?? "-"}
            </Typography>
          </Stack>

          <Stack sx={{ my: 1 }}>
            <Typography
              variant="body1"
              sx={{ fontWeight: 500, color: "#323F49" }}
            >
              Date of birth
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 400, color: "#323F49" }}
            >
              {reps_info?.dob ?? "-"}
            </Typography>
          </Stack>
          <Stack sx={{ my: 1 }}>
            <Typography
              variant="body1"
              sx={{ fontWeight: 500, color: "#323F49" }}
            >
              Email
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 400, color: "#323F49" }}
            >
              {reps_info?.email ?? "-"}
            </Typography>
          </Stack>
          {reps_info?.phone_number && (
            <Stack sx={{ my: 1 }}>
              <Typography
                variant="body1"
                sx={{ fontWeight: 500, color: "#323F49" }}
              >
                Contact No
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontWeight: 400, color: "#323F49" }}
              >
                {reps_info?.phone_number ?? "-"}
              </Typography>
            </Stack>
          )}

          <Stack sx={{ my: 1 }}>
            <Typography
              variant="body1"
              sx={{ fontWeight: 500, color: "#323F49" }}
            >
              State
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 400, color: "#323F49" }}
            >
              {reps_info?.state ?? "-"}
            </Typography>
          </Stack>
          <Stack sx={{ my: 1 }}>
            <Typography
              variant="body1"
              sx={{ fontWeight: 500, color: "#323F49" }}
            >
              Social Media
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 400, color: "#323F49" }}
            >
              -
            </Typography>
          </Stack>
          <Stack sx={{ my: 1 }}>
            <Typography
              variant="body1"
              sx={{ fontWeight: 500, color: "#323F49" }}
            >
              Account Type
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 400, color: "#323F49" }}
            >
              {reps_info?.account_type ?? "-"}
            </Typography>
          </Stack>
          <RepresentativeActivity reps_id={reps_info?.id} />

          {/* <Stack>
            <Typography variant="body1" color="black" sx={{ fontWeight: 600 }}>
              Message to Constituents
            </Typography>
            <Typography
              variant="body2"
              sx={{ fontWeight: 400, color: "#323F49" }}
            >
              I am here to serve you, the great people of Akoko-Edo. Your
              feedback, concerns, and suggestions are valuable to me as we work
              together to build a better community. Please feel free to reach
              out through any of the provided channels. Let’s continue to hold
              each other accountable and ensure that our constituency remains a
              model of growth and development.
            </Typography>
          </Stack> */}
        </Stack>
      </Box>
    </ContentLayout>
  );
};

export default RepresentativeContent;


